module.exports = __webpack_public_path__ + "media/images/admin/icons/align-justify-77cb95c962143ab9ab7318b51bdafedd.svg";